import Joi from 'joi'
import {inputPhoneValidation, inputStringValidation} from 'validation'

export const smsSchema = Joi.object({
  name: inputStringValidation.required().messages({
    'string.empty': `Name is not allowded to be empty`,
    'any.required': `Name is required`,
    'string.min': `Name should have a minimum length of 2`,
    'string.max': `Name should have a maximum length of 20`,
  }),
  provider: inputStringValidation.required().messages({
    'string.empty': `Provider is not allowded to be empty`,
    'any.required': `Provider is required`,
  }),
  authToken: Joi.string().required().messages({
    'string.empty': `Auth Token is not allowded to be empty`,
    'any.required': `Auth Token is required`,
  }),
  webhookUrl: Joi.string().when('provider', {
    is: 'custom_sms',
    then: Joi.string().required().messages({
      'any.required': `webhookurl is required`,
    }),
    otherwise: Joi.string().allow('', null),
  }),
  sid: Joi.string().when('provider', {
    is: 'twilio',
    then: Joi.string().required(),
  }),
  accountSID: Joi.any()
    .when('provider', {
      is: 'twilio',
      then: Joi.string().required(),
    })
    .label('auth key'),
  phoneNumber: Joi.string()
    .trim()
    .max(20)
    .regex(/^\+[0-9]{4,20}$/)
    .required()
    .messages({
      'string.pattern.base': 'Enter a valid phone number',
      'string.empty': 'phoneNo is required',
    }),
  threadingInterval: Joi.number().messages({
    'number.base': 'Threading interval must be required',
  }),
  assignees: Joi.array().items(Joi.alternatives(Joi.number(), Joi.string())).min(1).required().messages({
    'string.empty': `assignees is not allowded to be empty`,
    'any.required': `assignees is required`,
  }),
  autoResolvedDays: Joi.number(),
})
